import TimeAgo from './TimeAgo';

export default TimeAgo;
